import { render } from "./Coffee.vue?vue&type=template&id=05c9ef3e&scoped=true"
import script from "./Coffee.vue?vue&type=script&lang=js"
export * from "./Coffee.vue?vue&type=script&lang=js"

import "./Coffee.vue?vue&type=style&index=0&id=05c9ef3e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c9ef3e"]])

export default __exports__